/**
 * 左侧广告下载组件
 */
export default {
  name: 'boxLeftLink',
  props: {},
  data: function data() {
    return {};
  },
  methods: {}
};